
// --- 1. JOWUA CAR SELECTOR DATA ---
const jowuaCarSelectorData = {
    "Model S": { displayName: "Model S", options: { "model-s-2018-2020": { displayName: "2018-2020", tag: "Model S/X (2012-2020)" }, "model-s-2021+": { displayName: "2021-2025", tag: "model s 2021+" } } },
    "Model X": { displayName: "Model X", options: { "model-x-2018-2020": { displayName: "2018-2020", tag: "Model S/X (2012-2020)" }, "model-x-2021+": { displayName: "2021-2025", tag: "model x 2021+" } } },
    "Model 3": { displayName: "Model 3", options: { "model-3-pre-2021": { displayName: "Pre-2021 (2018-2020)", tag: "model 3 2018-2020" }, "model-3-2021-2023-std": { displayName: "2021 - 2023", tag: "model 3 2021-2023" }, "model-3-highland": { displayName: "2023+ (Highland)", tag: "new model 3 highland" }, "model-3-standard": { displayName: "Standard", tag: "model 3 standard" }, "model-3-highland-performance": { displayName: "Highland Performance", tag: "model 3 highland performance" } } },
    "Model Y": { displayName: "Model Y", options: { "model-y-pre-2021": { displayName: "Pre-2021 (2018-2020)", tag: "model y 2018-2020" }, "model-y-2021-2025-std": { displayName: "2021-2024", tag: "model y 2021-2023" }, "model-y-juniper": { displayName: "2025+ (Juniper)", tag: "model y juniper" }, "model-y-standard": { displayName: "Standard", tag: "model y standard" }, "model-y-juniper-performance": { displayName: "Performance", tag: "model y juniper performance" } } },
    "Cybertruck": { displayName: "Cybertruck", options: { "cybertruck-all": { displayName: "All Models", tag: "cybertruck" } } }
};
// --- END JOWUA CAR SELECTOR DATA ---

// --- 2. HELPER FUNCTION ---
function jowuaHandleize(str) {
    if (typeof str !== 'string' || !str.trim()) return '';
    return str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
}

// --- 3. MAIN SCRIPT LOGIC (Wrapped in DOMContentLoaded) ---
document.addEventListener('DOMContentLoaded', () => {
    console.log("JOWUA YMM: DOMContentLoaded fired."); // For initial check

    // IMMEDIATE localStorage check and button update
    const savedCarTag = localStorage.getItem('jowuaUserCarTag');
    const savedButtonText = localStorage.getItem('jowuaUserCarButtonText');

    if (savedCarTag && savedButtonText) {
        // Update buttons immediately if we have saved data
        const buttons = document.querySelectorAll('#jowua-vehicle-selector-btn-desktop, #jowua-vehicle-selector-btn-mobile');
        buttons.forEach(button => {
            const textSpan = button.querySelector('.jowua-btn-text');
            if (textSpan) {
                textSpan.textContent = savedButtonText;
                console.log("JOWUA YMM: Immediate button update to:", savedButtonText);
            }
        });
    }

    const modal = document.getElementById('jowua-vehicle-modal');
    const openModalBtnDesktop = document.getElementById('jowua-vehicle-selector-btn-desktop');
    const openModalBtnMobile = document.getElementById('jowua-vehicle-selector-btn-mobile');

    if (!modal) { console.warn("JOWUA YMM: Modal HTML not found."); }
    if (!openModalBtnDesktop && !openModalBtnMobile) { console.warn("JOWUA YMM: Neither header button found."); }

    const closeModalBtn = modal ? modal.querySelector('.jowua-modal-close-btn') : null;
    const yearSelect = modal ? document.getElementById('jowua-car-year') : null;
    const modelSelect = modal ? document.getElementById('jowua-car-model') : null;
    const variantSelect = modal ? document.getElementById('jowua-car-variant') : null;
    const saveCarBtn = modal ? document.getElementById('jowua-save-car-btn') : null;
    if (saveCarBtn) saveCarBtn.textContent = "Save Car"; // Hardcoded backup or passed via data-attribute ideally, but keeping JS literal for now to match logic flow

    const compatibleProductsBtn = modal ? document.getElementById('jowua-compatible-products-btn') : null;
    if (compatibleProductsBtn) compatibleProductsBtn.textContent = "All Compatible Products";

    const selectionFeedback = modal ? document.getElementById('jowua-selection-feedback') : null;

    // <<< ADDITION 1: Get reference to the remove button >>>
    const removeCarBtn = modal ? document.getElementById('jowua-remove-car-btn') : null;
    console.log("JOWUA YMM: Remove Car Button element:", removeCarBtn); // Debug

    if (modal && (!closeModalBtn || !yearSelect || !modelSelect || !variantSelect || !saveCarBtn || !compatibleProductsBtn || !selectionFeedback /* removed removeCarBtn from this check for now, as it's new */)) {
        console.warn("JOWUA YMM: One or more original elements inside the modal are missing.");
    }
    if (modal && !removeCarBtn) {
        console.warn("JOWUA YMM: The new 'jowua-remove-car-btn' was not found inside the modal.");
    }


    let selectedYearValue = null, selectedModelKey = null, selectedModelDisplayName = null,
        selectedVariantKey = null, selectedCarTag = null, selectedCarDisplayFullName = null,
        selectedCarButtonText = null;

    // --- Your existing functions from the "working version, no remove" ---
    function updateHeaderButtonText(buttonDisplayText) {
        const defaultText = "Add Your Tesla"; // We handle the text directly here since we moved out of liquid. Ideally passed via data-attributes.
        const textToShow = buttonDisplayText ? buttonDisplayText : defaultText;
        const showIcon = !!buttonDisplayText; // Show icon if a car is selected

        function setButtonContent(btnElement, text, displayIcon) {
            if (!btnElement) {
                console.log("JOWUA YMM: Button element not found for text update");
                return;
            }
            const iconPlaceholder = btnElement.querySelector('.jowua-btn-icon-placeholder');
            const textSpan = btnElement.querySelector('.jowua-btn-text');

            if (textSpan) {
                textSpan.textContent = text;
                // console.log("JOWUA YMM: Updated button text span to:", text);
            } else {
                btnElement.textContent = text; // Fallback if spans not present
                console.log("JOWUA YMM: Updated button text content to:", text);
            }

            if (iconPlaceholder) {
                iconPlaceholder.style.display = displayIcon ? 'inline-block' : 'none';
            }

            // Make button visible after text is set
            btnElement.style.opacity = '1';
        }

        console.log("JOWUA YMM: Updating header button text to:", textToShow);
        setButtonContent(openModalBtnDesktop, textToShow, showIcon);
        setButtonContent(openModalBtnMobile, textToShow, showIcon);
    }

    function openTheModal() {
        if (modal) {
            modal.style.display = 'block';
            if (modelSelect && (modelSelect.options.length <= 1 || (modelSelect.disabled && yearSelect && yearSelect.value))) {
                populateModels();
                if (yearSelect) modelSelect.disabled = !yearSelect.value;
            }
            // <<< ADDITION 2: Call to update remove button visibility when modal opens >>>
            updateRemoveButtonVisibility();
        }
    }

    function applyFitmentNotices() {
        const currentTagForComparison = (localStorage.getItem('jowuaUserCarTag') || '').toLowerCase();
        const carNameToDisplay = localStorage.getItem('jowuaUserCarButtonText') || "your car"; // Used for product cards
        let carFullNameToDisplay = localStorage.getItem('jowuaUserCarName') || "your car"; // Used for product pages

        // Clean the "All Years" from the display name right before using it.
        if (carFullNameToDisplay.toLowerCase().endsWith(' all years')) {
            carFullNameToDisplay = carFullNameToDisplay.substring(0, carFullNameToDisplay.length - 10).trim();
        } else if (carFullNameToDisplay.toLowerCase().endsWith(' all models')) {
            carFullNameToDisplay = carFullNameToDisplay.substring(0, carFullNameToDisplay.length - 11).trim();
        }

        const fitsStringTemplate = `✅ Fits your %%CAR_NAME%%`;
        const doesNotFitStringTemplate = `❌ Does not fit your %%CAR_NAME%%`;

        document.querySelectorAll('.jowua-fitment-notice').forEach(notice => notice.remove());
        document.querySelectorAll('.jowua-fitment-notice-placeholder-card').forEach(placeholder => {
            placeholder.classList.add('empty'); // Default to empty
            placeholder.innerHTML = '';
        });
        if (!currentTagForComparison || !carNameToDisplay) { return; }

        // Convert tag to Shopify handle for URL generation
        function shopifyHandleize(str) {
            return str
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphen
                .replace(/^-+|-+$/g, '')     // Remove leading/trailing hyphens
                .replace(/-+/g, '-');        // Remove duplicate hyphens
        }
        const tagHandle = shopifyHandleize(currentTagForComparison);
        const compatibleProductsUrl = tagHandle ? `/collections/all/${tagHandle}` : '#';

        document.querySelectorAll('[data-product-tags]').forEach(elementWithTags => {
            const isCard = elementWithTags.classList.contains('product-card');
            const placeholderSelector = isCard ? '.jowua-fitment-notice-placeholder-card' : '.jowua-fitment-notice-placeholder-page';
            const noticePlaceholder = elementWithTags.querySelector(placeholderSelector);
            if (!noticePlaceholder) { return; }
            const productTagsAttr = elementWithTags.getAttribute('data-product-tags');
            if (productTagsAttr) {
                const productTags = productTagsAttr.split('|||');
                let fits = productTags.includes(currentTagForComparison);

                // Create the fitment notice container
                const notice = document.createElement('div');
                notice.classList.add('jowua-fitment-notice');
                notice.classList.toggle('fits', fits);
                notice.classList.toggle('does-not-fit', !fits);

                if (isCard) {
                    const fitmentMessageText = fits
                        ? fitsStringTemplate.replace('%%CAR_NAME%%', carNameToDisplay)
                        : doesNotFitStringTemplate.replace('%%CAR_NAME%%', carNameToDisplay);
                    notice.textContent = fitmentMessageText;
                } else {
                    notice.classList.add('jowua-fitment-notice--enhanced');

                    const fitmentMessage = document.createElement('div');
                    fitmentMessage.classList.add('jowua-fitment-message');

                    const fitmentMessageText = fits
                        ? fitsStringTemplate.replace('%%CAR_NAME%%', carFullNameToDisplay)
                        : doesNotFitStringTemplate.replace('%%CAR_NAME%%', carFullNameToDisplay);
                    fitmentMessage.textContent = fitmentMessageText;

                    const linkMessage = document.createElement('div');
                    linkMessage.classList.add('jowua-fitment-link');
                    const iconUrl = "https://cdn.shopify.com/s/files/1/0462/3692/6108/files/finger_pointing.png?v=1752855537";
                    const linkText = fits
                        ? "See more products"
                        : "Show Fit Products";
                    const linkContent = `<img src="${iconUrl}" class="jowua-fitment-icon" alt="Find products for your car"> ${linkText}`;

                    linkMessage.innerHTML = `<a href="${compatibleProductsUrl}">${linkContent}</a>`;

                    notice.appendChild(fitmentMessage);
                    notice.appendChild(linkMessage);
                }

                noticePlaceholder.innerHTML = '';
                noticePlaceholder.appendChild(notice);
                noticePlaceholder.classList.remove('empty'); // Remove empty class if a message is present
            }
        });
    }

    function updateButtonStatesAndFeedback() {
        const canProceed = !!(selectedYearValue && selectedModelKey && selectedCarTag);
        if (saveCarBtn) saveCarBtn.disabled = !canProceed;
        if (compatibleProductsBtn) compatibleProductsBtn.disabled = !canProceed;
        if (selectionFeedback) {
            selectionFeedback.innerHTML = (canProceed && selectedCarDisplayFullName)
                ? `<span style="font-size: 1.1em; font-weight: 500;">Selected: ${selectedCarDisplayFullName}</span>`
                : '';
        }
    }

    function populateYears() { // This is your last working version of populateYears
        if (!yearSelect) { console.error("JOWUA YMM: yearSelect not found in populateYears"); return; }
        yearSelect.innerHTML = '<option value="">-- Select Year --</option>';
        const currentYear = new Date().getFullYear();
        for (let y = 2018; y <= 2026; y++) {
            const opt = document.createElement('option'); opt.value = y; opt.textContent = y; yearSelect.appendChild(opt);
        }
        if (modelSelect) modelSelect.disabled = true; // Start with model disabled
        console.log("JOWUA YMM: Years populated.");
    }

    function populateModels() { // This is your last working version of populateModels
        if (!modelSelect) { console.error("JOWUA YMM: modelSelect not found in populateModels"); return; }
        modelSelect.innerHTML = '<option value="">-- Select Model --</option>';
        if (typeof jowuaCarSelectorData === 'undefined' || !Object.keys(jowuaCarSelectorData).length) {
            modelSelect.disabled = true; console.error("JOWUA YMM: jowuaCarSelectorData missing in populateModels"); return;
        }
        // modelSelect.disabled is handled by yearSelect's event listener
        for (const key in jowuaCarSelectorData) {
            const opt = document.createElement('option'); opt.value = key; opt.textContent = jowuaCarSelectorData[key].displayName; modelSelect.appendChild(opt);
        }
        console.log("JOWUA YMM: Models populated.");
    }

    // <<< ADDITION 3: New function for "Remove Car" button visibility >>>
    function updateRemoveButtonVisibility() {
        if (!removeCarBtn) return;
        const savedTag = localStorage.getItem('jowuaUserCarTag');
        removeCarBtn.style.display = savedTag ? 'block' : 'none';
    }

    // MODIFIED loadSavedCar (from your "working version" but with remove button update)
    function loadSavedCar() {
        const savedStoredTag = (localStorage.getItem('jowuaUserCarTag') || '').toLowerCase();
        let savedFullName = localStorage.getItem('jowuaUserCarName');
        const savedButtonDisplayText = localStorage.getItem('jowuaUserCarButtonText');
        const savedYear = localStorage.getItem('jowuaUserCarYear');
        const savedModelKey = localStorage.getItem('jowuaUserCarModelKey');
        const savedVariantKey = localStorage.getItem('jowuaUserCarVariantKey');

        console.log("JOWUA YMM: Loading saved car data:", {
            tag: savedStoredTag,
            name: savedFullName,
            buttonText: savedButtonDisplayText,
            year: savedYear,
            modelKey: savedModelKey
        });

        // Reset globals before loading
        selectedCarTag = null; selectedCarDisplayFullName = null; selectedCarButtonText = null;
        selectedYearValue = null; selectedModelKey = null; selectedModelDisplayName = null; selectedVariantKey = null;

        let carActuallyLoaded = false;

        // Check if we have valid saved car data
        if (savedStoredTag && savedButtonDisplayText && savedFullName && savedYear && savedModelKey) {

            // Clean all variant information from the saved name on load
            if (savedFullName) {
                // Remove common variant patterns
                savedFullName = savedFullName
                    .replace(/\s*\([^)]*\)\s*$/g, '') // Remove anything in parentheses at the end
                    .replace(/\s*All Years\s*$/i, '') // Remove "All Years" at the end
                    .replace(/\s*All Models\s*$/i, '') // Remove "All Models" at the end
                    .replace(/\s*2021-\d{4}\s*$/g, '') // Remove year ranges like "2021-2024"
                    .replace(/\s*Pre-[A-Za-z]+\s*$/g, '') // Remove "Pre-Juniper" etc.
                    .trim();
            }

            // FORCE REGENERATION of Button Text to ensure it is always "Year + Model"
            if (jowuaCarSelectorData[savedModelKey]) {
                const modelName = jowuaCarSelectorData[savedModelKey].displayName;
                selectedCarButtonText = `${savedYear} ${modelName}`.trim();

                // FORCE REGENERATION of Full Name to ensure it is "Year + Make + Model (+ Variant)"
                // Note: savedFullName might be old. We rely on savedVariantKey later to refine this, 
                // but if we are just loading, we can try to improve it now or rely on the dispatch events.
                // For now, let's update the button text in storage immediately to fix product cards.
                localStorage.setItem('jowuaUserCarButtonText', selectedCarButtonText);
            } else {
                selectedCarButtonText = savedButtonDisplayText; // Fallback
            }

            selectedCarDisplayFullName = savedFullName;
            // selectedCarButtonText is already set above
            selectedYearValue = savedYear;
            selectedModelKey = savedModelKey;
            if (jowuaCarSelectorData[savedModelKey]) {
                selectedModelDisplayName = jowuaCarSelectorData[savedModelKey].displayName;
            }
            updateHeaderButtonText(selectedCarButtonText);
            carActuallyLoaded = true;
            console.log("JOWUA YMM: Car loaded with FORCED button text:", selectedCarButtonText);
        } else if (savedStoredTag && savedFullName && savedYear && savedModelKey && jowuaCarSelectorData[savedModelKey]) {
            // Clean all variant information from the saved name
            let cleanedFullName = savedFullName;
            if (cleanedFullName) {
                cleanedFullName = cleanedFullName
                    .replace(/\s*\([^)]*\)\s*$/g, '') // Remove anything in parentheses at the end
                    .replace(/\s*All Years\s*$/i, '') // Remove "All Years" at the end
                    .replace(/\s*All Models\s*$/i, '') // Remove "All Models" at the end
                    .replace(/\s*2021-\d{4}\s*$/g, '') // Remove year ranges like "2021-2024"
                    .replace(/\s*Pre-[A-Za-z]+\s*$/g, '') // Remove "Pre-Juniper" etc.
                    .trim();
            }
            selectedCarTag = savedStoredTag;
            selectedCarDisplayFullName = cleanedFullName;
            selectedYearValue = savedYear;
            selectedModelKey = savedModelKey;
            selectedModelDisplayName = jowuaCarSelectorData[savedModelKey].displayName;
            selectedCarButtonText = `${selectedYear} ${selectedModelDisplayName}`.trim();
            updateHeaderButtonText(selectedCarButtonText);
            carActuallyLoaded = true;
            console.log("JOWUA YMM: Car loaded with generated button text:", selectedCarButtonText);
        } else {
            updateHeaderButtonText(null); // Default "Add your Tesla"
            console.log("JOWUA YMM: No valid car data found, using default text");
        }

        if (carActuallyLoaded && modal) {
            if (yearSelect) yearSelect.value = selectedYearValue;
            if (modelSelect) {
                modelSelect.disabled = false; // Year is pre-filled, so enable model
                modelSelect.value = selectedModelKey;
                // Important: Dispatch change to populate variants correctly based on loaded year/model
                modelSelect.dispatchEvent(new Event('change'));

                if (variantSelect && savedVariantKey && savedVariantKey !== "N/A_MODEL_TAG") {
                    setTimeout(() => { // Allow variants to populate from modelSelect change
                        if (Array.from(variantSelect.options).some(opt => opt.value === savedVariantKey)) {
                            variantSelect.value = savedVariantKey;
                            variantSelect.dispatchEvent(new Event('change')); // To set final tag and display name
                        } else { updateButtonStatesAndFeedback(); }
                    }, 50); // Short delay
                } else if (savedVariantKey === "N/A_MODEL_TAG") {
                    selectedVariantKey = "N/A_MODEL_TAG"; // Restore special marker
                    updateButtonStatesAndFeedback();
                }
            }
        } else if (modal) { // No car loaded, but modal exists
            updateButtonStatesAndFeedback(); // Ensure modal buttons are in correct disabled state
        }

        applyFitmentNotices();
        updateRemoveButtonVisibility(); // <<< MODIFICATION: Call to show/hide remove button
    }

    // --- Event Listeners (from your "working version") ---
    if (openModalBtnMobile) openModalBtnMobile.onclick = openTheModal;
    if (openModalBtnDesktop) openModalBtnDesktop.onclick = openTheModal;

    if (modal) {
        if (closeModalBtn) closeModalBtn.onclick = () => { modal.style.display = 'none'; };
        window.onclick = (event) => { if (event.target == modal) modal.style.display = 'none'; };
    }

    if (yearSelect && modelSelect) { // Ensure both exist for this listener
        yearSelect.addEventListener('change', () => {
            selectedYearValue = yearSelect.value;
            if (selectedYearValue) {
                modelSelect.disabled = false;
                if (modelSelect.options.length <= 1) populateModels(); // Repopulate if empty

                if (selectedModelKey) {
                    modelSelect.dispatchEvent(new Event('change'));
                } else {
                    if (variantSelect) {
                        variantSelect.innerHTML = '<option value="">-- Select Variant --</option>';
                        variantSelect.disabled = true;
                    }
                    selectedVariantKey = null; selectedCarTag = null; selectedCarDisplayFullName = null; selectedCarButtonText = null;
                    updateButtonStatesAndFeedback();
                }
            } else {
                modelSelect.value = ""; modelSelect.disabled = true;
                if (variantSelect) {
                    variantSelect.innerHTML = '<option value="">-- Select Variant --</option>';
                    variantSelect.disabled = true;
                }
                selectedModelKey = null; selectedModelDisplayName = null;
                selectedVariantKey = null; selectedCarTag = null; selectedCarDisplayFullName = null; selectedCarButtonText = null;
                updateButtonStatesAndFeedback();
            }
        });
    }

    if (modelSelect && variantSelect) { // Ensure both exist
        modelSelect.addEventListener('change', () => {
            variantSelect.innerHTML = '<option value="">-- Select Variant --</option>'; variantSelect.disabled = true;
            selectedModelKey = modelSelect.value;
            selectedVariantKey = null; selectedCarTag = null; selectedCarDisplayFullName = null; selectedCarButtonText = null;
            const variantContainer = modal ? modal.querySelector('.jowua-variant-selector-container') : null;

            if (selectedModelKey && jowuaCarSelectorData[selectedModelKey]) {
                selectedModelDisplayName = jowuaCarSelectorData[selectedModelKey].displayName;
                const modelData = jowuaCarSelectorData[selectedModelKey];
                let firstVariantKey = null; let hasVisibleOptions = false;

                if (modelData.options && Object.keys(modelData.options).length > 0) {
                    for (const optionKey in modelData.options) {
                        let shouldShowOption = true;
                        if (selectedYearValue) {
                            const yearNum = parseInt(selectedYearValue);
                            if (selectedModelKey === "Model 3") {
                                if (yearNum === 2023) { if (optionKey !== "model-3-2021-2023-std" && optionKey !== "model-3-highland") shouldShowOption = false; }
                                else if (yearNum < 2021) { if (optionKey !== "model-3-pre-2021") shouldShowOption = false; }
                                else if (yearNum > 2023 && yearNum < 2025) { if (optionKey !== "model-3-highland") shouldShowOption = false; }
                                else if (yearNum >= 2025) { if (optionKey !== "model-3-highland" && optionKey !== "model-3-standard" && optionKey !== "model-3-highland-performance") shouldShowOption = false; }
                                else { if (optionKey !== "model-3-2021-2023-std") shouldShowOption = false; }
                            } else if (selectedModelKey === "Model Y") {
                                if (yearNum === 2025) { if (optionKey !== "model-y-2021-2025-std" && optionKey !== "model-y-juniper" && optionKey !== "model-y-standard" && optionKey !== "model-y-juniper-performance") shouldShowOption = false; }
                                else if (yearNum < 2021 && modelData.options["model-y-pre-2021"]) { if (optionKey !== "model-y-pre-2021") shouldShowOption = false; }
                                else if (yearNum >= 2021 && yearNum < 2025) { if (optionKey !== "model-y-2021-2025-std") shouldShowOption = false; }
                                else if (yearNum > 2025) { if (optionKey !== "model-y-juniper" && optionKey !== "model-y-standard" && optionKey !== "model-y-juniper-performance") shouldShowOption = false; }
                            } else if (selectedModelKey === "Model S") {
                                if (yearNum >= 2018 && yearNum <= 2020) { if (optionKey !== "model-s-2018-2020") shouldShowOption = false; }
                                else if (yearNum >= 2021) { if (optionKey !== "model-s-2021+") shouldShowOption = false; }
                            } else if (selectedModelKey === "Model X") {
                                if (yearNum >= 2018 && yearNum <= 2020) { if (optionKey !== "model-x-2018-2020") shouldShowOption = false; }
                                else if (yearNum >= 2021) { if (optionKey !== "model-x-2021+") shouldShowOption = false; }
                            }
                        }
                        if (shouldShowOption) {
                            hasVisibleOptions = true;
                            const option = document.createElement('option'); option.value = optionKey; option.textContent = modelData.options[optionKey].displayName; variantSelect.appendChild(option);
                            if (!firstVariantKey) firstVariantKey = optionKey;
                        }
                    }
                }
                if (variantContainer) variantContainer.style.display = hasVisibleOptions ? '' : 'none';
                if (hasVisibleOptions) {
                    variantSelect.disabled = false;
                    if (variantContainer && getComputedStyle(variantContainer).display === 'none' && firstVariantKey) {
                        variantSelect.value = firstVariantKey; variantSelect.dispatchEvent(new Event('change')); return;
                    }
                } else {
                    variantSelect.disabled = true;
                    if (modelData.tag) {
                        selectedCarTag = modelData.tag.toLowerCase();
                        // Add "Tesla" for full name
                        selectedCarDisplayFullName = `${selectedYearValue || ''} Tesla ${selectedModelDisplayName || ''}`.trim();
                        selectedCarButtonText = `${selectedYearValue || ''} ${selectedModelDisplayName || ''}`.trim();
                        selectedVariantKey = "N/A_MODEL_TAG";
                    }
                }
            } else {
                selectedModelKey = null; selectedModelDisplayName = null;
                if (variantContainer) variantContainer.style.display = 'none';
            }
            updateButtonStatesAndFeedback();
        });
    }

    if (variantSelect) { // Ensure it exists
        variantSelect.addEventListener('change', () => {
            selectedVariantKey = variantSelect.value;
            if (selectedModelKey && selectedVariantKey && selectedVariantKey !== "N/A_MODEL_TAG") {
                if (jowuaCarSelectorData[selectedModelKey] && jowuaCarSelectorData[selectedModelKey].options[selectedVariantKey]) {
                    const variantData = jowuaCarSelectorData[selectedModelKey].options[selectedVariantKey];
                    selectedCarTag = variantData.tag.toLowerCase();

                    // For product page display, we DO want variant information now AND "Tesla"
                    selectedCarDisplayFullName = `${selectedYearValue || ''} Tesla ${selectedModelDisplayName || ''} ${variantData.displayName || ''}`.trim();
                    // Button text (and Product Card text) should be Year + Model ONLY
                    selectedCarButtonText = `${selectedYearValue || ''} ${selectedModelDisplayName || ''}`.trim();
                }
            } else if (!(selectedModelKey && selectedVariantKey === "N/A_MODEL_TAG")) {
                selectedVariantKey = null; selectedCarTag = null; selectedCarDisplayFullName = null; selectedCarButtonText = null;
            }
            updateButtonStatesAndFeedback();
        });
    }

    if (saveCarBtn) { // Ensure it exists
        saveCarBtn.onclick = () => {
            if (selectedCarTag && selectedCarDisplayFullName && selectedYearValue && selectedCarButtonText) { // Use selectedCarButtonText for condition
                localStorage.setItem('jowuaUserCarTag', selectedCarTag);
                localStorage.setItem('jowuaUserCarName', selectedCarDisplayFullName);
                localStorage.setItem('jowuaUserCarButtonText', selectedCarButtonText);
                localStorage.setItem('jowuaUserCarYear', selectedYearValue);
                localStorage.setItem('jowuaUserCarModelKey', selectedModelKey);
                if (selectedVariantKey && selectedVariantKey !== "N/A_MODEL_TAG") localStorage.setItem('jowuaUserCarVariantKey', selectedVariantKey);
                else localStorage.removeItem('jowuaUserCarVariantKey');
                updateHeaderButtonText(selectedCarButtonText);
                if (modal) modal.style.display = 'none';
                applyFitmentNotices();
                updateRemoveButtonVisibility(); // <<< MODIFICATION: Call to show remove button
                setTimeout(updateShineAnimation, 100); // Add animation update
            }
        };
    }

    if (compatibleProductsBtn) { // Ensure it exists
        compatibleProductsBtn.onclick = () => {
            if (selectedCarTag && selectedCarDisplayFullName && selectedYearValue && selectedCarButtonText) {
                // First save the car selection
                localStorage.setItem('jowuaUserCarTag', selectedCarTag);
                localStorage.setItem('jowuaUserCarName', selectedCarDisplayFullName);
                localStorage.setItem('jowuaUserCarButtonText', selectedCarButtonText);
                localStorage.setItem('jowuaUserCarYear', selectedYearValue);
                localStorage.setItem('jowuaUserCarModelKey', selectedModelKey);
                if (selectedVariantKey && selectedVariantKey !== "N/A_MODEL_TAG") localStorage.setItem('jowuaUserCarVariantKey', selectedVariantKey);
                else localStorage.removeItem('jowuaUserCarVariantKey');

                // Update the header button text
                updateHeaderButtonText(selectedCarButtonText);

                // Close the modal
                if (modal) modal.style.display = 'none';

                // Apply fitment notices
                applyFitmentNotices();
                updateRemoveButtonVisibility();

                // Convert tag to Shopify handle
                function shopifyHandleize(str) {
                    return str
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphen
                        .replace(/^-+|-+$/g, '')     // Remove leading/trailing hyphens
                        .replace(/-+/g, '-');        // Remove duplicate hyphens
                }
                const tagHandle = shopifyHandleize(selectedCarTag);
                if (tagHandle) {
                    const finalUrl = `/collections/all/${tagHandle}`;
                    window.location.href = finalUrl;
                } else {
                    console.warn("JOWUA YMM: Could not generate handle from tag:", selectedCarTag);
                }
            } else {
                console.warn("JOWUA YMM: No selectedCarTag for compatible products link.");
            }
        };
    }

    // <<< ADDITION 4: Event listener for "Remove Car" button >>>
    if (removeCarBtn) {
        removeCarBtn.onclick = () => {
            console.log("JOWUA YMM: Remove Car button clicked.");
            localStorage.removeItem('jowuaUserCarTag');
            localStorage.removeItem('jowuaUserCarName');
            localStorage.removeItem('jowuaUserCarButtonText');
            localStorage.removeItem('jowuaUserCarYear');
            localStorage.removeItem('jowuaUserCarModelKey');
            localStorage.removeItem('jowuaUserCarVariantKey');

            selectedYearValue = null; selectedModelKey = null; selectedModelDisplayName = null;
            selectedVariantKey = null; selectedCarTag = null; selectedCarDisplayFullName = null;
            selectedCarButtonText = null;

            updateHeaderButtonText(null); // Resets to "Add your Tesla"
            document.querySelectorAll('.jowua-fitment-notice').forEach(notice => notice.remove());

            // Reset modal dropdowns to initial state
            if (yearSelect) yearSelect.value = "";
            if (modelSelect) {
                // DO NOT REPOPULATE HERE, just clear and disable. openTheModal will repopulate if needed.
                modelSelect.innerHTML = '<option value="">-- Select Model --</option>';
                modelSelect.disabled = true;
            }
            if (variantSelect) {
                variantSelect.innerHTML = '<option value="">-- Select Variant --</option>';
                variantSelect.disabled = true;
            }
            if (selectionFeedback) selectionFeedback.textContent = "";

            updateButtonStatesAndFeedback(); // This will disable save/compatible buttons
            updateRemoveButtonVisibility(); // This will hide the removeCarBtn itself
            setTimeout(updateShineAnimation, 100); // Add animation update

            if (modal) modal.style.display = 'none';
        };
    }

    // --- E. Section Load/Pagination Event Listeners ---
    document.addEventListener('shopify:section:load', function (event) {
        // Check if we are on a collection page template
        if (document.body.getAttribute('data-template') && document.body.getAttribute('data-template').includes('collection')) {
            console.log('JOWUA YMM: "shopify:section:load" event detected. Section ID:', event.detail.sectionId, 'Re-applying fitment notices.');
            // Delay to allow DOM updates by the theme to complete
            setTimeout(applyFitmentNotices, 250);
        }
    });

    document.addEventListener('blocs:section:load', function (event) { // For Prestige theme or similar
        if (document.body.getAttribute('data-template') && document.body.getAttribute('data-template').includes('collection')) {
            console.log('JOWUA YMM: "blocs:section:load" event detected. Re-applying fitment notices.');
            setTimeout(applyFitmentNotices, 250);
        }
    });

    // Fallback click listener for pagination - more robust
    // This will catch any click on a pagination link inside a collection
    // and re-apply fitment notices after a short delay

    document.addEventListener('click', function (event) {
        // Match any anchor inside .pagination, not just those with is="facet-link"
        const paginationLink = event.target.closest('.pagination a, a.pagination__link');
        if (paginationLink) {
            console.log('JOWUA YMM: Pagination link clicked. Re-applying fitment notices after AJAX load.');
            // This delay needs to be long enough for the AJAX content to load and replace
            setTimeout(applyFitmentNotices, 750);
        }
    }, true); // Use capture phase to catch it, though not strictly necessary



    // --- H. COMPATIBILITY & TRACKING (Migrated from theme.liquid) ---

    // 1. Cart Attributes System
    function addYMMCartAttributes() {
        try {
            // console.log('JOWUA: Checking for YMM car tag...');
            const urlParams = new URLSearchParams(window.location.search);
            const ymmCar = urlParams.get('ymm_car');

            if (ymmCar) {
                // First check if cart exists
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        if (cart.item_count > 0) {
                            // Prepare cart attributes - only car tag and app usage
                            const cartAttributes = {
                                'YMM_Car': ymmCar,
                                'YMM_APP': 'Used'
                            };

                            // Update cart with attributes
                            return fetch('/cart/update.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ attributes: cartAttributes })
                            });
                        }
                    })
                    .then(response => response ? response.json() : null)
                    .then(data => {
                        if (data) {
                            console.log('JOWUA: Cart updated with YMM attributes:', data);
                        }
                    })
                    .catch(error => {
                        console.error('JOWUA: Error checking/updating cart:', error);
                    });
            }
        } catch (e) {
            console.error('JOWUA: An error occurred in the YMM cart attribute script.', e);
        }
    }

    // Run once after page load (delayed to ensure other scripts run)
    setTimeout(addYMMCartAttributes, 2000);


    // 2. URL Persistence System
    function addYMMCarToURL() {
        const userCarTag = localStorage.getItem('jowuaUserCarTag');
        if (userCarTag && !window.location.search.includes('ymm_car')) {
            // console.log('JOWUA: Adding YMM car tag to URL...');
            const url = new URL(window.location);
            url.searchParams.set('ymm_car', userCarTag);
            window.history.replaceState({}, '', url);
            // console.log('JOWUA: URL updated with YMM car tag');
        }
    }

    function setupYMMTracking() {
        // Watch for YMM app usage (modal appearing)
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === 1 && node.classList && node.classList.contains('jowua-modal')) {
                            addYMMCarToURL();
                        }
                    });
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Also check if YMM data already exists on load
        const userCarTag = localStorage.getItem('jowuaUserCarTag');
        if (userCarTag) {
            addYMMCarToURL();
        }
    }
    setupYMMTracking();


    // 3. Form Submission Handler (Inject Attributes into Cart Forms)
    document.addEventListener('submit', function (event) {
        // Target all product forms on the site
        if (event.target.closest('form[action*="/cart/add"]')) {
            const form = event.target.closest('form[action*="/cart/add"]');
            const userCarTag = localStorage.getItem('jowuaUserCarTag');

            if (userCarTag) {
                // Remove existing fields if they're there to prevent duplicates
                form.querySelectorAll('input[name="attributes[YMM_Car]"], input[name="attributes[YMM_APP]"]').forEach(input => input.remove());

                // Create and append the hidden input for the car tag
                const carInput = document.createElement('input');
                carInput.type = 'hidden';
                carInput.name = 'attributes[YMM_Car]';
                carInput.value = userCarTag;
                form.appendChild(carInput);

                // Create and append the hidden input for the app usage
                const appInput = document.createElement('input');
                appInput.type = 'hidden';
                appInput.name = 'attributes[YMM_APP]';
                appInput.value = 'Used';
                form.appendChild(appInput);

                console.log('JOWUA: YMM attributes added to cart form.', { car: userCarTag });
            }
        }
    }, true); // Use capture


    // --- F. INITIALIZE ---
    function initializeYMM() {
        if (modal) {
            populateYears();
            populateModels();
        }

        // Load saved car immediately
        loadSavedCar();
        updateShineAnimation();
    }

    // --- G. ANIMATION CONTROL ---
    function updateShineAnimation() {
        const savedCarTag = localStorage.getItem('jowuaUserCarTag');
        const buttons = [openModalBtnDesktop, openModalBtnMobile].filter(Boolean);

        buttons.forEach(button => {
            if (savedCarTag) {
                button.classList.add('car-selected');
            } else {
                button.classList.remove('car-selected');
            }
        });
    }

    // Initialize immediately
    initializeYMM();

    // --- Robust MutationObserver for AJAX collection pagination/filters ---
    function setupProductListObserver() {
        let parent = document.querySelector('.collection__main') || document.querySelector('.container');
        if (!parent || typeof MutationObserver === 'undefined') return;
        let observer = new MutationObserver((mutationsList, observer) => {
            try {
                const productList = parent.querySelector('.product-list');
                if (productList) {
                    applyFitmentNotices();
                    observer.disconnect(); // Remove observer to avoid loops
                    // Re-attach observer to the new product-list after a short delay
                    setTimeout(setupProductListObserver, 500);
                }
            } catch (e) {
                console.error('JOWUA YMM: MutationObserver error', e);
            }
        });
        observer.observe(parent, { childList: true, subtree: true });
    }
    setupProductListObserver();

});
